export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9094.47787f52.jpg";